import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { TextLoca } from "../generic/text/TextLoca";
export var LeaguePrizesAvailableSoon = function () {
    return (React.createElement("div", { className: IdStyles.LeagueButtonContainer + " flex flex--guts flex--wrap league-prizes__center-elements h100" },
        React.createElement(TextLoca, { id: IdLoca.comingSoon, className: IdStyles.TextButtonDefault })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/LeaguePrizesAvailableSoon.tsx
// module id = 2793
// module chunks = 3